<template>
  <div id="alarminfoContent">
    <div class="data_head">
      <el-button type="primary" @click="alarmDialog=true" class="searchButton">添&nbsp;加</el-button>
    </div>
    <div class="table tableContent">
      <el-table  :data="dataList" style="width: 100%;" stripe :header-cell-style="{background:'#335ABB',color:'#FFF'}">
        <el-table-column align="center"  prop="alarmName" label="报警器名称"></el-table-column>
        <el-table-column align="center"  prop="alarmVolume" label="修改音量指令"></el-table-column>
        <el-table-column align="center"  prop="alarmStart" label="开启指令"></el-table-column>
        <el-table-column align="center"  prop="alarmEnd" label="关闭指令"></el-table-column>
        <el-table-column align="center"  label="操作" fixed="right" width="300">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="mini" @click="handleCheck(scope.row)" type="primary">修改</el-button>
              <el-button size="mini" @click="handleDelete(scope.row)" type="danger">删除</el-button>
              <el-button size="mini" @click="binDing(scope.row)" type="success">绑定测点</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="添加报警设备" center :visible.sync="alarmDialog" width="40%" :modal-append-to-body="false">
      <el-form label-width="80px" :model="alarmForm" ref="ruleForm" :rules="rules" >
        <el-form-item label="设备名称" prop="alarmName"><el-input v-model="alarmForm.alarmName"></el-input></el-form-item>
        <el-form-item label="声量指令" prop="alarmVolume"><el-input v-model="alarmForm.alarmVolume"></el-input></el-form-item>
        <el-form-item label="开启指令" prop="alarmStart"><el-input v-model="alarmForm.alarmStart"></el-input></el-form-item>
        <el-form-item label="关闭指令" prop="alarmEnd"><el-input v-model="alarmForm.alarmEnd"></el-input></el-form-item>
        <el-form-item align="right">
          <el-button type="primary"  @click="addAlarm('ruleForm')">确定</el-button>
          <el-button type="info"  @click="alarmDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--修改-->
    <el-dialog title="修改信息" center :visible.sync="updataDialog" width="40%" :modal-append-to-body="false">
      <el-form label-width="80px" :model="updataForm" ref="updataForm" :rules="rules" >
        <el-form-item label="设备名称" prop="alarmName"><el-input v-model="updataForm.alarmName"></el-input></el-form-item>
        <el-form-item label="声量指令" prop="alarmVolume"><el-input v-model="updataForm.alarmVolume"></el-input></el-form-item>
        <el-form-item label="开启指令" prop="alarmStart"><el-input v-model="updataForm.alarmStart"></el-input></el-form-item>
        <el-form-item label="关闭指令" prop="alarmEnd"><el-input v-model="updataForm.alarmEnd"></el-input></el-form-item>
        <el-form-item align="right">
          <el-button type="primary"  @click="updataAlarm('updataForm')">确定</el-button>
          <el-button type="info"  @click="updataDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--绑定测点-->
    <el-dialog title="绑定测点" center :visible.sync="bindDialog" width="40%" :modal-append-to-body="false"   :close-on-click-modal="false">
      <el-form label-width="80px" :model="setBindForm" ref="bindForm" :rules="rulesBind"  >
        <el-form-item label="测点选择" prop="measures">
          <el-cascader
            v-model="setBindForm.measures"
            :options="paramOptions"
            :props="{value:'code',label:'name',children:'childHashSet',emitPath:false,multiple:true}"
            :show-all-levels="false"
            collapse-tags
          ></el-cascader>
        </el-form-item>
        <el-form-item align="center">
          <el-button type="primary"  @click="bindPoint('bindForm')">绑定</el-button>
          <el-button type="info"  @click="bindDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


  </div>
</template>

<script>
    export default {
        name: "AlarmInfor",
        data(){
            return{
                dataList:[],
                alarmDialog:false,
                alarmForm:{
                    alarmName:'',
                    alarmVolume:'',
                    alarmStart:'',
                    alarmEnd:''
                },
                rules:{
                    alarmName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
                    alarmVolume: [{ required: true, message: '请输入声音指令', trigger: 'blur' }],
                    alarmStart: [{ required: true, message: '请输入开始指令', trigger: 'blur' }],
                    alarmEnd: [{ required: true, message: '请输入关闭指令', trigger: 'blur' }],
                },
                updataDialog:false,
                updataForm:{
                    id:'',
                    alarmName:'',
                    alarmVolume:'',
                    alarmStart:'',
                    alarmEnd:''
                },
                bindDialog:false, //绑定测点
                paramOptions:[],
                rulesBind:{
                    measures: [{ required: true, message: '请选择测点', trigger: 'change' }]
                },
                setBindForm:{
                    measures:[],
                    id:""
                }
            }
        },
        mounted(){
            this.getdataList()
        },
        methods:{
            /*添加确定按钮*/
            addAlarm(formName){
                this.$refs[formName].validate((valid) => {
                    if(valid){
                        this.$axios.post('/api/monitor/project/saveAlarmApparatus',this.alarmForm).then(res=>{
                            if (res.data.status == 200) {
                                this.$message({ message: '添加成功', type: 'success' })
                                this.alarmDialog = false
                                this.getdataList()
                                this.$refs[formName].resetFields();
                            }else{
                                if(res.data.datas.values){
                                    this.$message({ message: res.data.datas.values, type: 'error' })
                                }else{
                                    this.$message({ message: res.data.message, type: 'error' })
                                }
                            }
                        })
                    } else { this.$message({ message: '有必填项未填哦，再检查下吧！', type: 'error' })}
                })
            },
            /*获取数据列表*/
            getdataList(){
                this.$axios.get('/api/monitor/project/getAlarmApparatus').then(res=>{
                    if (res.data.status == 200) {
                        this.dataList = res.data.datas.values;
                    }
                    return
                })
            },
            //编辑
            handleCheck(info){
                this.$axios.get('/api/monitor/project/getOne?id='+info.id).then(res=>{
                    if(res.data.status == 200){
                        this.updataForm.id=info.id
                        this.updataForm.alarmName=res.data.datas.values.alarmName
                        this.updataForm.alarmVolume=res.data.datas.values.alarmVolume
                        this.updataForm.alarmStart=res.data.datas.values.alarmStart
                        this.updataForm.alarmEnd=res.data.datas.values.alarmEnd
                        this.updataDialog = true
                    }else{this.$message({message:res.data.message,type:'error'})}
                })
            },
            updataAlarm(formName){
                this.$refs[formName].validate((valid) => {
                    if(valid){
                        this.$axios.put('/api/monitor/project/updateAlarmApparatusById',this.updataForm).then(res=>{
                            if (res.data.status == 200) {
                                this.$message({ message: '修改成功', type: 'success' })
                                this.updataDialog = false
                                this.getdataList()
                                this.$refs[formName].resetFields();
                            }else{
                                this.$message({ message: res.data.message, type: 'error' })
                            }
                        })
                    } else { this.$message({ message: '有必填项未填哦，再检查下吧！', type: 'error' })}
                })
            },
            handleDelete(info){
                this.$confirm('是否删除当前报警器', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.delete('/api/monitor/project/deleteAlarmApparatusById?id='+info.id).then(res=>{
                        if(res.data.status == 200) {
                            this.$message({ message: '删除成功', type: 'success' })
                            this.getdataList()
                        } else {
                            if(res.data.datas.values){
                                this.$message({ message: res.data.datas.values, type: 'error' })
                            }else{
                                this.$message({ message: res.data.message, type: 'error' })
                            }
                        }
                    })
                })

            },
        //    绑定测点
            binDing(info){
                this.setBindForm.id=info.id
                this.$axios.get("/api/monitor/dataHistory/getMeasureByCode",this.setBindForm).then(res => {
                    if(res.data.status==200){
                        this.paramOptions = res.data.datas.values;
                        this.getPoint(info.id)
                        this.bindDialog=true
                    }else{this.$message.error(res.data.message)}
                });
            },
        //    获取已有测点project/getBindingAlarmMeasures
            getPoint(id){
                this.$axios.get("/api/monitor/project/getBindingAlarmMeasures?alarmId="+id).then(res=>{
                    // measureNo
                    res.data.datas.values.forEach(item=>{
                        this.setBindForm.measures.push(item.measureNo)
                    })
                })
            },
            // 保存
            bindPoint(formName){
                this.$refs[formName].validate((valid) => {
                    if(valid){
                        this.$axios.post('/api/monitor/project/bindingAlarmMeasures',this.setBindForm).then(res=>{
                            if(res.data.status==200){
                                this.bindDialog=false
                                this.$message.success('绑定成功')
                            }else {
                                this.bindDialog=true
                                this.$message.warning(res.data.message)
                            }
                        })
                    } else { this.$message({ message: '有必填项未填哦，再检查下吧！', type: 'warning' })}
                })
            }
        }
    }
</script>

<style>
  .el-dialog__header {
    text-align: center;
    padding: 20px 30px 10px;
    /*background-image: url('../../assets/img/modal_bg.png')*/
    background: linear-gradient(
      -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%) !important;
    border-radius: 2.5px 2.5px 0px 0px;
    transition: unset;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }

  .el-dialog__title {
    text-align: center;
    font-size: 18px;
    color: #fff;
  }

  /*#alarminfoContent .el-cascader .el-input  .el-input__inner{*/
  /*  color: #FFF;*/
  /*  background-color: #3457DE;*/
  /*}*/

  #alarminfoContent .el-date-editor .el-input__inner{
    background-color: #3457DE;
    color: #FFF;
  }

  #alarminfoContent .el-table{
    color: #A7CCF6;
  }

  #alarminfoContent .el-table__row {
    background-color: #0B3A68 !important;
  }

  #alarminfoContent .el-table--striped .el-table__body tr.el-table__row--striped td{
    background-color: #021535;
  }

  #alarminfoContent .el-table td{
    border: unset;
  }

  #alarminfoContent .el-table th.is-leaf{
    border-bottom: none;
  }
  #alarminfoContent .el-form-item{
    margin: 20px 0;
  }

</style>

<style scoped>
  @import url('../../assets/css/style.css');

</style>



// WEBPACK FOOTER //
// src/components/project/alarmInfor.vue